/**
 * Created by razial on 26.05.2025.
 */

const FlatMapSaver = {
    EMPTY_CELL: " ",
    FOG_CELL: "~",

    loadUnitsCache: function (field) {
        if (field.mapCache) {
            return;
        }

        field.mapCache = {};

        let units = field.slot.load("units");
        let props = field.slot.load("details");

        units = (units || "").split(";");
        props = (props || "").split(";");

        const propertiesCache = (props.shift() || "").split(",")
            .map((property) => property.split(":"));

        const broken = [];

        for (let y = 0; y < units.length; ++y) {
            const row = units[y] || "";
            
            for (let x = 0, i = 0; i < row.length;) {
                const itemLength = [this.EMPTY_CELL, this.FOG_CELL].includes(row[i]) ? 1 : 3;
                const chunk = row.slice(i, i + itemLength);
                const info = this.expandUnit(chunk);
                if (info === null) {
                    broken.push(`${x - 1}_${y - 1}:${chunk}`);
                } else if (info) {
                    field.mapCache[`${x - 1}_${y - 1}`] = info;
                }
                i += itemLength;
                x++;
            }
        }

        if (broken.length) {
            cleverapps.throwAsync(`FlatMapSaver skipped broken units: ${broken.join(" ")}`);
        }

        for (let i = 0; i < props.length; ++i) {
            const info = Base80.expandExtendedSequence(props[i]);
            const unit = field.mapCache[`${info[0] - 1}_${info[1] - 1}`];

            if (info.length < 3 || !unit) {
                continue;
            }

            for (let j = 2; j < info.length; ++j) {
                const propertyKeyValue = propertiesCache[info[j]];

                if (propertyKeyValue.length === 2) {
                    unit[propertyKeyValue[0]] = Base80.expandNumber(propertyKeyValue[1]);
                }
            }
        }
    },

    saveUnitsCache: function (field) {
        const mapCache = field.mapCache;

        const unitsMap = [];

        let compactUnits = "";
        let compactProps = "";

        let propertiesCount = 0;
        let propertiesCache = {};

        Object.keys(mapCache).forEach((key) => {
            const info = mapCache[key];
            let [x, y] = key.split("_");
            x++;
            y++;

            if (unitsMap[y] === undefined) {
                unitsMap[y] = [];
            }

            if (unitsMap[y][x] === undefined) {
                unitsMap[y][x] = [];
            }
            
            unitsMap[y][x] = this.compactUnit(info);

            if (unitsMap[y][x] === this.FOG_CELL) {
                return;
            }

            let properties = "";

            for (const key in info) {
                const value = info[key];

                if (key === "code" || key === "stage" || key === "grounded" || value === null || value === undefined) {
                    continue;
                }

                if (!Number.isInteger(value)) {
                    throw `only integers are allowed in unit properties ${info.code} ${info.stage} ${value}`;
                }

                const property = `${key}:${Base80.compactNumber(info[key])}`;

                let propertyIndex = propertiesCache[property];
                if (propertyIndex === undefined) {
                    propertyIndex = propertiesCache[property] = propertiesCount;
                    propertiesCount += 1;
                }

                properties += Base80.compactExtendedNumber(propertyIndex);
            }

            if (properties.length) {
                if (compactProps.length) {
                    compactProps += ";";
                }
                compactProps += Base80.compactExtendedNumber(x) + Base80.compactExtendedNumber(y) + properties;
            }
        });

        for (let y = 0; y < unitsMap.length; ++y) {
            for (let x = 0; unitsMap[y] && x < unitsMap[y].length; ++x) {
                const emptyChar = this.EMPTY_CELL;
                compactUnits += unitsMap[y][x] || emptyChar;
            }

            if (y !== unitsMap.length - 1) {
                compactUnits += ";";
            }
        }

        propertiesCache = Object.keys(propertiesCache).sort((a, b) => propertiesCache[a] - propertiesCache[b]).join(",");

        compactProps = propertiesCache.length && compactProps.length ? `${propertiesCache};${compactProps}` : "";

        field.slot.save("units", compactUnits);
        field.slot.save("details", compactProps);
    },

    compactUnit: function (info) {
        if (info.fog || info.grounded) {
            return this.FOG_CELL;
        }

        if (info.code.length > 2) {
            throw `wrong unit code format - can be only one or two characters ${info.code} ${info.stage}`;
        }

        return this.encodeUnit(info);
    },

    expandUnit: function (value) {
        if (value === this.EMPTY_CELL) {
            return;
        }

        if (value === this.FOG_CELL) {
            return { fog: true };
        }

        return this.decodeUnit(value);
    },

    encodeUnit: function (info) {
        let code = info.code;
        let stage = info.stage;

        if (code === "Z") {
            code = "E";
            stage += 11;
        }

        if (!Number.isInteger(stage) || stage < 0 || stage >= Base80.STR.length) {
            cleverapps.throwAsync(`FlatMapSaver wrong stage: ${info.code} ${info.stage}`);
            return this.EMPTY_CELL;
        }

        return code.padStart(2, "_") + Base80.compactNumber(stage);
    },

    decodeUnit: function (value) {
        if (value.length < 3) {
            return null;
        }

        let code = value.slice(0, 2).replace("_", "");
        let stage = Base80.expandNumber(value[2]);

        if (Number.isNaN(stage)) {
            return null;
        }

        if (code === "E" && stage >= 11) {
            code = "Z";
            stage -= 11;
        }

        return { code, stage };
    },

    loadUnit: function (field, x, y) {
        this.loadUnitsCache(field);

        const unit = field.mapCache[`${x}_${y}`];
        if (unit) {
            return { ...unit };
        }
    },

    saveUnit: function (field, x, y, info) {
        this.loadUnitsCache(field);

        field.mapCache[`${x}_${y}`] = info;

        this.saveUnitsCache(field);
    },

    removeUnit: function (field, x, y) {
        this.loadUnitsCache(field);

        delete field.mapCache[`${x}_${y}`];

        this.saveUnitsCache(field);
    }
};
